function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "path-1-inside-1",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 4.99988V28.9999L3.99768 32.9976H28.0023L32 28.9999V4.99988L28 0.999878L28.0023 0.997559H3.99768L4 0.999878L0 4.99988Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 4.99988V28.9999L3.99768 32.9976H28.0023L32 28.9999V4.99988L28 0.999878L28.0023 0.997559H3.99768L4 0.999878L0 4.99988Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 4.99988L-0.707107 4.29277L-1 4.58566V4.99988H0ZM0 28.9999H-1V29.4141L-0.707107 29.707L0 28.9999ZM3.99768 32.9976L3.29057 33.7047L3.58347 33.9976H3.99768V32.9976ZM28.0023 32.9976V33.9976H28.4165L28.7094 33.7047L28.0023 32.9976ZM32 28.9999L32.7071 29.707L33 29.4141V28.9999H32ZM32 4.99988H33V4.58566L32.7071 4.29277L32 4.99988ZM28 0.999878L27.2929 0.292771L26.5858 0.999878L27.2929 1.70698L28 0.999878ZM28.0023 0.997559L28.7094 1.70467L30.4165 -0.00244141H28.0023V0.997559ZM3.99768 0.997559V-0.00244141H1.58347L3.29057 1.70467L3.99768 0.997559ZM4 0.999878L4.70711 1.70698L5.41421 0.999878L4.70711 0.292771L4 0.999878ZM-1 4.99988V28.9999H1V4.99988H-1ZM-0.707107 29.707L3.29057 33.7047L4.70479 32.2905L0.707107 28.2928L-0.707107 29.707ZM3.99768 33.9976H28.0023V31.9976H3.99768V33.9976ZM28.7094 33.7047L32.7071 29.707L31.2929 28.2928L27.2952 32.2905L28.7094 33.7047ZM33 28.9999V4.99988H31V28.9999H33ZM32.7071 4.29277L28.7071 0.292771L27.2929 1.70698L31.2929 5.70698L32.7071 4.29277ZM28.7071 1.70698L28.7094 1.70467L27.2952 0.290452L27.2929 0.292771L28.7071 1.70698ZM28.0023 -0.00244141H3.99768V1.99756H28.0023V-0.00244141ZM3.29057 1.70467L3.29289 1.70698L4.70711 0.292771L4.70479 0.290452L3.29057 1.70467ZM3.29289 0.292771L-0.707107 4.29277L0.707107 5.70698L4.70711 1.70698L3.29289 0.292771Z",
  fill: "#B0BAC9",
  mask: "url(#path-1-inside-1)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.1305 9.26947C20.4234 9.56237 20.4234 10.0372 20.1305 10.3301L13.4609 16.9998L20.1305 23.6695C20.4234 23.9624 20.4234 24.4372 20.1305 24.7301C19.8376 25.023 19.3628 25.023 19.0699 24.7301L11.8699 17.5301C11.7292 17.3895 11.6502 17.1987 11.6502 16.9998C11.6502 16.8009 11.7292 16.6101 11.8699 16.4695L19.0699 9.26947C19.3628 8.97658 19.8376 8.97658 20.1305 9.26947Z",
  fill: "#B0BAC9"
});

var SvgBackButton = function SvgBackButton(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back-button.dbea043b.svg";
export { ForwardRef as ReactComponent };